// Settings.js
import React from 'react';
import Sidebar from './sidebar';
import Navbar from './navbar';
import Footer from './footer';
const Settings = () => {
  return (
    <div className="layout">
    <Sidebar />
    <div className="main-content">
      <Navbar />
      <div className="content">
     <p>THis is Setting page</p>
      </div>
      <Footer />
    </div>
  </div>
  );
};

export default Settings;
